import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../api/types';

interface Props {
  roles: UserRole[];
  redirectTo?: string;
}

export default function RoleGuard({ roles, redirectTo = '/dashboard' }: Props) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const allowed = roles.includes(user.role) || (user.role === 'super_admin' && roles.includes('admin'));
  if (!allowed) return <Navigate to={redirectTo} replace />;
  return <Outlet />;
}
